import styled from 'styled-components'

import { Grid } from '@interco/inter-ui/components/Grid'

export const HeaderInfosGrid = styled(Grid)`
  grid-template-columns: 64px 2fr;
  gap: 16px;
`

export const ConnectionsCard = styled.div`
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  margin-bottom: 16px;
  padding: 16px;
`

export const BulletList = styled.li`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const BulletPoint = styled.span`
  width: 5px;
  height: 5px;
  background-color: var(--primary-color, #010101);
  border-radius: 50%;
  flex-shrink: 0;
`
